import { render, staticRenderFns } from "./questionWarning.vue?vue&type=template&id=e59d310c&"
import script from "./questionWarning.vue?vue&type=script&lang=js&"
export * from "./questionWarning.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports